(function () {
  'use strict';

  function initLoadMore() {
    const btn = document.querySelector('[data-load-more-btn]');
    if (!btn) return;
    if (btn.dataset.loadMoreReady) return;
    btn.dataset.loadMoreReady = 'true';
    btn.addEventListener('click', handleLoadMore);
    console.log('[LoadMore] Button initialised');
  }

  async function handleLoadMore(e) {
    const btn = e.currentTarget;
    const rawNextUrl = btn.dataset.nextUrl;
    if (!rawNextUrl) return;

    const grid = document.querySelector('#main-collection-product-grid ol');
    if (!grid) return;

    const nextUrl = getNextUrlWithCurrentSort(rawNextUrl);
    setLoading(btn, true);

    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newItems = doc.querySelectorAll('[data-product-list] [data-collection-product]');

      newItems.forEach((item) => {
        item.style.opacity = '0';
        item.style.transition = 'opacity 0.3s ease';
        grid.appendChild(item);
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            item.style.opacity = '1';
          });
        });
      });

      const nextBtn = doc.querySelector('[data-load-more-btn]');
      if (nextBtn) {
        btn.dataset.nextUrl = nextBtn.dataset.nextUrl;
        setLoading(btn, false);
      } else {
        const wrapper = btn.closest('.pagination-wrapper');
        if (wrapper) {
          wrapper.style.transition = 'opacity 0.3s ease';
          wrapper.style.opacity = '0';
          setTimeout(() => wrapper.remove(), 300);
        } else {
          btn.remove();
        }
      }
    } catch (err) {
      console.error('[LoadMore] Failed to fetch next page:', err);
      setLoading(btn, false);
    }
  }

  function getNextUrlWithCurrentSort(nextUrl) {
    const currentParams = new URLSearchParams(window.location.search);
    const sortBy = currentParams.get('sort_by');
    const url = new URL(nextUrl, window.location.origin);
    if (sortBy) {
      url.searchParams.set('sort_by', sortBy);
    } else {
      url.searchParams.delete('sort_by');
    }
    return url.toString();
  }

  function setLoading(btn, isLoading) {
    const label = btn.querySelector('[data-load-more-label]');
    const spinner = btn.querySelector('[data-load-more-spinner]');
    btn.disabled = isLoading;
    btn.setAttribute('aria-busy', isLoading);
    if (label) label.style.visibility = isLoading ? 'hidden' : 'visible';
    if (spinner) spinner.style.display = isLoading ? 'inline-block' : 'none';
  }

  document.addEventListener('DOMContentLoaded', initLoadMore);

  window.addEventListener('collection:rerendered', () => {
    setTimeout(() => {
      const btn = document.querySelector('[data-load-more-btn]');
      if (btn) delete btn.dataset.loadMoreReady;
      initLoadMore();
    }, 300);
  });

})();